import { useState } from 'react';

import { FindSamplesResponse } from '@/types';

const useSamples = () => {
  const [columns, setColumns] = useState<{ key: string; value: string }[]>([]);
  const [samples, setSamples] = useState<FindSamplesResponse[]>([]);

  return { columns, samples, setColumns, setSamples };
};

export default useSamples;
